import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-pt-2 ns-pb-2 ns-mb-3">
                <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div class="ns-selected-filter ns-d-flex ns-align-items-center ns-px-1 ns-mr-1 ns-mb-1">
                            <span class="ns-color-black">
                                {filter.name}: {filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <a
                    href="javascript:void(0)"
                    class="ns-col-2 ns-text-undecorated ns-text-align-right ns-color-link ns-ml-2 ns-mr-0 ns-ml-auto clearFilters"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear Filters
                </a>
            </div>
        )
    )
}
